







































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as models from '@/api/models';
import * as api from '@/api';
import moment from 'moment';
@Component({ components: {} })
export default class QsStatistics extends Vue {
  chartOptions = {};
  totalUpNumbers: number = 0;
  totalYsNumbers: number = 0;
  listData: any = [];
  listQuery: any = {
    currentStartDate: '',
    startDate: null,
    endDate: null,
    type: '',
  };

  search() {
    this.fetchData();
  }
  switchWeek(type: string) {
    console.log('%c [ type ]-94', 'font-size:13px; background:pink; color:#bf2c9f;', type);
    this.listQuery.type = type;
    this.listData = [];
    this.fetchData();
  }
  mounted() {
    this.fetchData();
  }
  async fetchData() {
    const data: any = await api.Yq.getDayStatistics_GET({
      st: this.listQuery.st ? new Date(new Date(new Date(this.listQuery.st).toLocaleDateString()).getTime()) : null,
      et: this.listQuery.et
        ? new Date(new Date(new Date(this.listQuery.et).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
        : null,
      startDate: this.listQuery.type ? this.listQuery.currentStartDate : null,
      endDate: this.listQuery.endDate,
      type: this.listQuery.type,
      city: '',
      county: '',
    });
    this.listData = data.data.result;
    //先清空，避免查询影响
    this.listQuery.currentStartDate = '';
    this.listQuery.currentStartDate = data.data.currentStartDate;
    this.chartOptions = {};

    if (this.listData) {
      //先清空，避免合计错误
      this.totalUpNumbers = 0;
      this.totalYsNumbers = 0;
      //统计上报舆情数量、疑似敏感信息数量
      this.listData.forEach((item: any, index: number) => {
        this.totalUpNumbers += item.Number;
        this.totalYsNumbers += item.suspected;
      });
      this.getChart(this.listData);
    }
  }
  getWeekDay(date: Date) {
    let week;
    let dateFormat = new Date(moment(date).format('YYYY-MM-DD'));
    if (dateFormat.getDay() == 0) week = '星期日';
    if (dateFormat.getDay() == 1) week = '星期一';
    if (dateFormat.getDay() == 2) week = '星期二';
    if (dateFormat.getDay() == 3) week = '星期三';
    if (dateFormat.getDay() == 4) week = '星期四';
    if (dateFormat.getDay() == 5) week = '星期五';
    if (dateFormat.getDay() == 6) week = '星期六';
    return week;
  }

  getChart(listData: any) {
    let that = this;
    let titleName =
      (this.listData && this.listData.length > 7 ? '' : '本周') +
      '舆情数量趋势' +
      '<br/>' +
      '<span style="font-size:13px;">' +
      moment(that.listData[0].Time).format('YYYY-MM-DD') +
      '~' +
      moment(that.listData[that.listData.length - 1].Time).format('YYYY-MM-DD') +
      '</span>';
    let weeks: any = [];
    let sbyqs: any = [];
    if (that.listData) {
      that.listData.forEach((item: any) => {
        let week = '';
        sbyqs.push(item.Number);
        week = that.getWeekDay(item.Time)!;
        weeks.push(week);
      });
    }

    let template = {
      title: {
        text: titleName,
      },
      xAxis: {
        //自定义x轴
        categories: weeks,
      },
      yAxis: {
        title: { text: '数量(条)' },
      },
      credits: {
        //去掉水印
        enabled: false,
      },
      plotOptions: {
        line: {
          //显示点
          dataLabels: {
            enabled: true,
          },
        },
      },
      series: [
        {
          name: '上报舆情',
          data: sbyqs,
          color: 'red',
        },
      ],
    };
    this.chartOptions = template;
  }
}
